import React from 'react';
import { NAVIGATE_PEOPLE_NAV_ITEM_NUDGE } from '@atlassian/jira-onboarding-core/src/constants.tsx';
import { OnboardingNudgeErrorBoundary } from '@atlassian/jira-onboarding-quickstart-core/src/common/ui/onboarding-nudge-error-boundary/index.tsx';
import type { QuickstartNudgeWrapperBaseProps } from '@atlassian/jira-onboarding-quickstart-core/src/common/ui/quickstart-nudge/types.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const NavigationPeopleNavItemLazy = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-software-onboarding-navigation-people-nudge" */ './index'
		).then((exportedModule) => exportedModule.NavigationPeopleNavItemWrapperNudge),
	{
		ssr: false,
	},
);
export const NavigationPeopleNavItemWrapperNudgeAsync = ({
	children,
	isInsideMenu,
}: QuickstartNudgeWrapperBaseProps) => (
	<OnboardingNudgeErrorBoundary
		id={NAVIGATE_PEOPLE_NAV_ITEM_NUDGE}
		fallback={children}
		attributes={{
			nudgeId: NAVIGATE_PEOPLE_NAV_ITEM_NUDGE,
		}}
	>
		<Placeholder name="navigation-people-nav-item-lazy" fallback={<>{children}</>}>
			<NavigationPeopleNavItemLazy
				nudgeId={NAVIGATE_PEOPLE_NAV_ITEM_NUDGE}
				isInsideMenu={isInsideMenu}
			>
				{children}
			</NavigationPeopleNavItemLazy>
		</Placeholder>
	</OnboardingNudgeErrorBoundary>
);
